import React, { createContext, useState, useContext, useEffect } from "react";
import axios from "axios";

// Create a Context for the order
const OrderContext = createContext();

// Create a custom hook to use the order context
export const useOrder = () => {
  return useContext(OrderContext);
};

// Create a provider component for the order
export const OrderProvider = ({ children }) => {
  const [order, setOrder] = useState([]);
  const [qtyAlert, setQtyAlert] = useState([]);
  const [availableTickets, setAvailableTickets] = useState([]);
  const url = "https://dev.pmwevents.com";

  useEffect(() => {
    axios
      .get(`${url}/sbc/get-active-sbc`)
      .then((res) => {
        getEvent(res.data[0].eventId);
      })
      .catch((err) => {
        console.log("Could not get active SBC events");
      });
  }, []);

  //THIS GETS TICKETS FOR A SPECIFIC EVENT
  const getEvent = async (id) => {
    localStorage.setItem("eventId", id);
    const eventId = {
      event: id,
    };
    await axios
      .post(`${url}/sbc/get-sbc-not-all`, eventId)
      .then((res) => {
        setAvailableTickets(res.data);
      })
      .catch((err) => {
        console.log(err);
        console.log("Could not get details of SBC Event");
      });
  };

  // Function to add a product to the order
  const addToOrder = (product) => {
    const inOrder = order.findIndex((o) => o.typeId === product.typeId);

    const matchingTicket = availableTickets.find(
      (t) => t.ticketTypeId === product.typeId
    );

    if (!matchingTicket) {
      console.warn("Ticket type not found");
      return;
    }

    const currentQty = inOrder >= 0 ? order[inOrder].qty : 0;
    const totalQty = parseInt(matchingTicket.ticketSales) + currentQty;

    if (totalQty >= matchingTicket.maxTickets) {
      setQtyAlert(`Sorry no more ${product.name} tickets available`);
      setTimeout(() => {
        setQtyAlert("");
      }, 2000);
      return;
    }

    if (inOrder === -1) {
      setOrder([
        ...order,
        {
          ...product,
          qty: 1,
          totalWithVat: product.withVat,
          total: product.price,
        },
      ]);
    } else {
      const newOrder = order.map((o, i) =>
        i === inOrder
          ? {
              ...o,
              qty: o.qty + 1,
              total: o.total + o.price,
              totalWithVat: o.totalWithVat + o.withVat,
            }
          : o
      );
      if (JSON.stringify(order) !== JSON.stringify(newOrder)) {
        setOrder(newOrder);
      }
      // setOrder(newOrder);
    }
  };
  // Function to remove a product from the order
  const removeFromOrder = (product, clearAll = false) => {
    if (product.qty === 1 || clearAll) {
      setOrder((prevOrder) =>
        prevOrder.filter((p) => p.typeId !== product.typeId)
      );
    } else {
      let newOrder = order.map((o) => {
        if (o.typeId === product.typeId) {
          return {
            ...o,
            qty: o.qty - 1,
            total: o.total - o.price,
            totalWithVat: o.totalWithVat - o.withVat,
          };
        } else {
          return o;
        }
      });
      if (JSON.stringify(order) !== JSON.stringify(newOrder)) {
        setOrder(newOrder);
      }
      // setOrder(newOrder);
    }
  };

  // Function to clear the order
  const clearOrder = () => {
    setOrder([]);
  };

  return (
    <OrderContext.Provider
      value={{ order, addToOrder, removeFromOrder, clearOrder, qtyAlert }}
    >
      {children}
    </OrderContext.Provider>
  );
};
